import CoreRouter from "./routes";

function App() {
  return (
    <CoreRouter />
  );
}

export default App;
